var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconSuperpacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 86,
    viewBox: "0 0 76 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_20",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 86
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 0H0V86H76V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9_20",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 77,
    height: 86
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2113 0H3.21127V86H79.2113V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7104 86H14.4623C10.2153 86 6.77377 83.0134 6.77377 79.3278V73.4816V61.7893V16.6722C6.77377 12.9866 10.2153 10 14.4623 10H53.7104C57.9573 10 61.3988 12.9866 61.3988 16.6722V79.3278C61.3988 83.0134 57.9573 86 53.7104 86ZM10.1421 76.4045V79.3278C10.1421 81.4248 12.1192 83.0768 14.4623 83.0768H53.7104C56.1268 83.0768 58.0305 81.4248 58.0305 79.3278V16.6722C58.0305 14.5753 56.1268 12.9231 53.7104 12.9231H14.4623C12.046 12.9231 10.1421 14.6388 10.1421 16.6722V58.8662V76.4045Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5238 80H37.6488",
    stroke: "#424242",
    strokeWidth: 1.66
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2738 17.0004C35.2738 17.5525 34.7424 18 34.0858 18C33.4302 18 32.8988 17.5525 32.8988 17.0004C32.8988 16.4475 33.4302 16 34.0858 16C34.7424 16 35.2738 16.4475 35.2738 17.0004Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8988 76L54.2738 75.9606V19.9999H13.8988V76Z",
    fill: "#FF8300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3988 51.4172C42.4099 48.6536 40.9828 46.7364 35.5874 45.4566C32.653 44.7387 31.9557 44.3503 31.9557 43.3873C31.9557 42.6841 32.4458 41.9368 33.9453 41.9368C35.9238 41.9368 36.2604 42.9891 36.4364 43.6884H41.8974C41.6768 41.1542 39.9022 39.1948 36.0576 38.675V37H31.9323V38.6888C28.472 39.2311 26.2004 41.2121 26.2004 44.0306C26.2004 46.653 27.613 48.5428 33.3026 49.8962C35.8615 50.5052 36.5421 51.0053 36.5421 52.0655C36.5421 52.8736 36.003 53.615 34.2494 53.615C32.6552 53.615 31.6437 52.8775 31.3329 51.6742H25.7738C25.9889 54.3309 28.0442 56.4031 32.0948 56.919V59H36.2391V56.915C39.9556 56.4443 42.3787 54.6457 42.3988 51.4172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9114 9.72042L71.4216 7.42328L66.2704 10.0231L67.7603 12.3203L72.9114 9.72042Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3776 2.2571L64.0051 0.637558L60.3734 4.77827L62.746 6.39786L66.3776 2.2571Z",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.398 16.1869L69.5114 16.8513L69.8922 19.4764L75.7789 18.812L75.398 16.1869Z",
    fill: "#FF7900"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconSuperpacks);
export default __webpack_public_path__ + "static/media/menuIcon-Superpacks.a707f0637161f48bb20e4c111359c63c.svg";
export { ForwardRef as ReactComponent };